import { parseResponse } from "../../utils/parseResponse";
import {
    OpenClubs, PromoterGroupOpneClubsModel
} from "../../types";
import { promoterGroupOpenClubsKeys } from "../responseKeys/responseKeys";
import { PromoterGroupOpenClubsApiResponse } from "../responses/PromoterGroupOpenClubsApiResponse";

export function parseOpenClubsResponse(openClubs: string[] | undefined): PromoterGroupOpneClubsModel {

    return {
        openClubs: openClubs?.map((el) =>
            parseResponse<OpenClubs>(el, promoterGroupOpenClubsKeys.openClubs, ["ClubId"])
        )
    };
}
